import { exec, getApiToken } from '../utils';
import type {
  GetRepairDetailArgs,
  GetRepairDetailExecVariables,
  GetRepairDetailExecResponse,
  RepairDetailType,
} from '@src/types';

const gql = String.raw;

/**
 * Fetches detailed information for a single repair including items, issues, timeline, and customer info
 * Automatically exchanges JWT for badge token if needed
 * @param args - Partner code and repair UUID
 * @returns Promise resolving to detailed repair data
 */
export const getRepairDetail = async (
  args: GetRepairDetailArgs
): Promise<RepairDetailType> => {
  const { token } = sessionStorage;

  const apiToken = await getApiToken(token);

  const searchQuery = gql`
    query getRepairDetails(
      $token: String!
      $partnerCode: String!
      $uuid: String!
    ) {
      restUser(token: $token) {
        repairDetail(
          partnerCode: $partnerCode
          uuid: $uuid
        ) {
          uuid
          uuidPrefix
          status
          price
          promoCode
          shippingPrice
          currencyCode
          inboundShippingInfo {
            trackingNumber
            trackingUrl
            carrier
          }
          outboundShippingInfo {
            trackingNumber
            trackingUrl
            carrier
          }
          customer {
            name
            email
            phone
            address
          }
          dateInitiated
          dateUpdated
          repairItems {
            uuid
            uuidPrefix
            status
            problemTypes
            dateUpdated
            notes
            title
            imageUrls
            repairItemIssues {
              uuid
              uuidPrefix
              status
              problem
              location
              severity
              dateUpdated
              price
              initiatedPrice
              notes
            }
          }
          timeline {
            eventDate
            description
          }
        }
      }
    }
  `;

  const variables: GetRepairDetailExecVariables = {
    ...args,
    token: apiToken,
  };

  const data = await exec<
    GetRepairDetailExecVariables,
    GetRepairDetailExecResponse
  >(searchQuery, {
    variables,
  });

  return data.restUser.repairDetail;
};
